import 'core-js/stable';
import 'regenerator-runtime/runtime';

import WeakMap from 'weakmap';
import ReactDOM from 'react-dom';
import React from 'react';
import Dictionary from '../react_dictionary';

window.WeakMap = WeakMap;

function initComponents() {
  const element = document.getElementById('react-dictionary');
  const { apiUrl } = element.dataset;
  const { field } = element.dataset;
  const localization = JSON.parse(element.dataset.localization);

  ReactDOM.render(
    <Dictionary apiUrl={apiUrl} localization={localization} field={field}/>,
    element,
  );
}

document.addEventListener('DOMContentLoaded', () => {
  initComponents();
});
